// oxlint-disable-next-line typescript/triple-slash-reference -- upstream omits its shipped declaration from package exports
/// <reference path="./extra-array-length.d.ts" />

export { default } from "@extra-array/length";
